import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router, ActivatedRoute } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { parseJSON } from 'jquery';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'deposit-skrill.component',
  templateUrl: '../sharedTemplates/deposit-skrill.component.html',
})
export class DepositSkrillComponent implements OnInit, AfterViewInit {
  DepositTypeId = 74;

  MinValue = 0;
  MaxValue = 0;

  coinbaseDatas: UntypedFormGroup;
  coinbaseDataRaw: any;
  firststep = true;
  insicstatus = '2';
  typeid = 0;
  statu = '0';
  formvalid = false;
  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper,
    private domSanitizer: DomSanitizer,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(params => {
      //orderid/:ordercode/:goapihash
      this.DepositTypeId = params['depositId'];
      this.getDepositInfo();
    });

    this.coinbaseDatas = _FormBuilder.group({
      amount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(5), Validators.min(10), Validators.max(10000)]),
    });
  }

  ngOnInit() {
    this.coinbaseDatas.valueChanges.subscribe(x => {
      this.coinbaseDataRaw = x;
    });

    this.route.params.subscribe(params => {
      //orderid/:ordercode/:goapihash
      this.statu = params['typeid'];

      if (this.statu != '0') {
        if (window.self !== window.top) {
          // checking if it is an iframe
          window.parent.location.href = '/depositskrill/' + this.statu;
        } else {
          this._ApiService.getClient2().then().catch();
        }
      }
    });
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('Skrill', true);
    const translator = new TranslatePipe(this._LocalizationService);

    if (this._UserHelper.customerUser.CustomerId !== undefined) {
      this._ApiService
        .getInsicStatus()
        .then(res => {
          this.insicstatus = res;
        })
        .catch(err => {
          console.log('deposit-skrill, getInsicStatus', err);
          this._UiHelper.errorSnackBar(translator.transform('InsicStatusCatchErrorMessage', null), '');
        });
    }

    this.route.params.subscribe(params => {
      //orderid/:ordercode/:goapihash
      this.typeid = params['typeid'];
    });
  }
  iframesrc;
  submitCoinbaseData() {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService.depositSkrill(this.coinbaseDatas.value.amount, this.typeid).then(result => {
      this._UiHelper.setLoadingDialog(false);
      const translator = new TranslatePipe(this._LocalizationService);
      const apcoresult = JSON.parse(result);
      if (apcoresult.result == 'success') {
        this.firststep = false;
        this.iframesrc = this.domSanitizer.bypassSecurityTrustResourceUrl(apcoresult.desc);
      } else {
        this._UiHelper.errorSnackBar(apcoresult.desc, '');
      }
    });
  }

  changeAmount(e) {
    this.coinbaseDatas.patchValue({ amount: e });
    this.formvalid = true;
  }

  paymentpageLoaded() {
    this._UiHelper.setLoadingDialog(false);
  }

  getDepositInfo() {
    this._ApiService.getAllDepositControl3().then(result => {
      //console.log("getDeposit--",result.filter(item => item.DepositTypeId == this.DepositTypeId));

      const depositInfo = result.filter(item => item.DepositTypeId == this.DepositTypeId);

      if (depositInfo == null || depositInfo.length == 0) {
        this.coinbaseDatas = this._FormBuilder.group({
          amount: new UntypedFormControl({ value: '', disabled: true }, [
            Validators.required,
            Validators.maxLength(5),
            Validators.min(this.MinValue),
            Validators.max(this.MaxValue),
          ]),
        });
      } else {
        this.MinValue = depositInfo[0].MinValue;
        this.MaxValue = depositInfo[0].MaxValue;

        if (depositInfo.length > 0) {
          this.coinbaseDatas = this._FormBuilder.group({
            amount: new UntypedFormControl({ value: '', disabled: false }, [
              Validators.required,
              Validators.maxLength(5),
              Validators.min(this.MinValue),
              Validators.max(this.MaxValue),
            ]),
          });
        }
      }
    });
  }
}
